import { apiRequest } from './axiosConfig';
import { CREDIT_REFRESH_EVENT } from './creditService';

export interface OnboardingBonusCredits {
  product: number;
  generate: number;
  plan: number;
}

export interface OnboardingV2Progress {
  product_done: boolean;
  generate_done: boolean;
  plan_done: boolean;
  bonus_credits: OnboardingBonusCredits;
  /**
   * 組織が無料10枚バナー生成を未使用なら true（バックエンドが追加予定）。
   * 実装前は欠落しうるため利用側は `?? false` でフォールバックする。
   */
  free_banner_available?: boolean;
}

export interface OnboardingV2GrantedNow {
  product: boolean;
  generate: boolean;
  plan: boolean;
}

export interface OnboardingV2ClaimResponse {
  granted_now: OnboardingV2GrantedNow;
  progress: OnboardingV2Progress;
  bonus_credits: OnboardingBonusCredits;
}

export const dispatchCreditRefreshIfGranted = (grantedNow: OnboardingV2GrantedNow): void => {
  if (grantedNow.product || grantedNow.generate || grantedNow.plan) {
    window.dispatchEvent(new Event(CREDIT_REFRESH_EVENT));
  }
};

const onboardingV2Service = {
  getProgress: async (): Promise<OnboardingV2Progress> => {
    return apiRequest.get<OnboardingV2Progress>('users/onboarding/v2/progress');
  },

  claim: async (): Promise<OnboardingV2ClaimResponse> => {
    const response = await apiRequest.post<OnboardingV2ClaimResponse>('users/onboarding/v2/claim');
    dispatchCreditRefreshIfGranted(response.granted_now);

    return response;
  },
};

export default onboardingV2Service;
